import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import "./Navbar.css";
import Modal from "../Modal";
import Cart from "../pages/Cart";
import { useCart } from "../Contexts/CartProvider"

const Navbar = () => {
  let data = useCart();
  const [cartView, setCartView] = useState(false);
  const navigate = useNavigate();
  const logout = () => {
    localStorage.removeItem("authToken");
    navigate("/login");
  };
  return (
    <nav className="navbar">
      <div className="brand-logo">
        <Link to="/">HungryHub</Link>
      </div>
      <div className="navbar-links">
        <Link to="/">
          <button className="navbar-link home-link">Home</button>
        </Link>
        {localStorage.getItem("authToken") ? (
          <Link to="/myorder">
            <button className="navbar-link home-link">
              My Orders
            </button>
          </Link>
        ) : (
          ""
        )}
        {localStorage.getItem("authToken") ? (
          <div>
            <Link>
              <button className="navbar-link home-link" onClick={() => { setCartView(true) }}>
                My Cart {data.length === 0 ? "" : <span>{data.length}</span>}
              </button>
            </Link>
            {cartView ? <Modal onClose={() => setCartView(false)}><Cart></Cart></Modal> : ""}
            <Link>
              <button onClick={logout} className="logout-button navbar-link">
                Logout
              </button>
            </Link>
          </div>
        ) : (
          <div>
            <Link to="/login">
              <button className="login-signup-button navbar-link">Login</button>
            </Link>
            <Link to="/signup">
              <button className="login-signup-button navbar-link">
                SignUp
              </button>
            </Link>
          </div>
        )}
      </div>
    </nav>
  );
};

export default Navbar;
